import axios from 'axios';

// Create axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001'),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Log API calls in development
    if (process.env.NODE_ENV === 'development') {
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor (basic logging only - auth handling is done in AuthContext)
api.interceptors.response.use(
  (response) => {
    // Log successful responses in development
    if (process.env.NODE_ENV === 'development') {
    }
    return response;
  },
  (error) => {
    // Note: 401 handling is done in AuthContext.js to allow for token refresh
    return Promise.reject(error);
  }
);

export default api;